// extracted by mini-css-extract-plugin
module.exports = {"stats":"CDmt","statsBlock":"CDmv","dateWrap":"CDmx","date":"CDg7","dateIcon":"CDmz","item":"CDat","photoIcon":"CDm1","videoIcon":"CDm3","musicIcon":"CDm5","comments":"CDm7"};